import React from 'react';
import { motion } from 'motion/react';
import { Calendar } from 'lucide-react';
import Navigation from './Navigation';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      {/* Opening Info Banner */}
      <motion.div 
        className="bg-gradient-to-r from-blue-600/90 to-purple-600/90 backdrop-blur-sm py-2 sm:py-2 px-3 sm:px-4"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-center items-center text-white text-xs sm:text-sm gap-4 sm:gap-8">
          {/*
          <motion.div 
            className="flex items-center space-x-2 mb-1 sm:mb-0"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <Calendar className="w-4 h-4 sm:w-4 sm:h-4" />
            <span className="font-medium text-center">Soft Opening Oct 10, 2025</span>
          </motion.div>
          
          <motion.div 
            className="flex items-center space-x-2"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <Calendar className="w-4 h-4 sm:w-4 sm:h-4" />
            <span className="font-medium text-center">Grand Opening Oct 31, 2025</span>
          </motion.div>
          */}
        </div>
      </motion.div>
      
      <Navigation />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;